import SDIcon from './SDIcon'

const IconCarbonPower = (props) => (
  <SDIcon title='Power' {...props}>
    <path d='M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z' transform='translate(0)' />
    <rect x='15' y='2' width='2' height='14' />
  </SDIcon>
)

export default IconCarbonPower
